import { isHistorical } from '@sdk/unavailabilities/helpers/utils';
class UnavailabilitySetController {
  constructor(
    Authentication,
    PersonaCollection,
    AvailabilityUtils,
    UserUtils,
    $timeout,
    $state,
    $scope,
    $rootScope,
    $location,
    $window
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      PersonaCollection,
      AvailabilityUtils,
      UserUtils,
      $timeout,
      $state,
      $scope,
      $rootScope,
      $location,
      $window,
    });
  }

  availabilitySets = [];
  availabilityLoading = false;

  $onInit() {
    if (!this.user && this.userId) {
      this.user = this.PersonaCollection.personasDict[this.userId];
    }

    this.init();
    if (!this.availabilityForm) {
      this.availabilityForm = {};
    }

    if (this.$state.params.newSet) {
      this.isNewSet = true;
      this.setUnavailabilityData({ data: this.availabilitySets });
    }

    if (!this.goBack) {
      this.goBack = () => this.$window.history.back();
    }

    this.$scope.$watch('ctrl.availabilitySets[0].availabilityId', (newVal, oldVal) => {
      if ((oldVal && !newVal) || (!oldVal && newVal && this.isNewSet)) {
        this.goBack();
      }
    });
  }

  async init() {
    if (this.setId) {
      this.availabilityLoading = true;

      try {
        const setData = await this.AvailabilityUtils.getSingleUnavailabilitySet(this.setId);
        if (this.$state.params.editSet) {
          setData._editing = true;
        }

        this.availabilitySets = [setData];
        this.availabilityLoading = false;
      } catch (e) {
        this.availabilityLoading = true;
        this.$state.go('users.profile', { userId: this.$state.params.userId, tab: 'availability' });
      }
    } else if (this.setData) {
      this.availabilitySets = this.setData;
    } else if (this.$state.params.newSet) {
      const copyFromSet = this.$state.params.copySet;
      this.availabilitySets.unshift(
        this.AvailabilityUtils.createAvailabilitySet(this.user, copyFromSet)
      );
      this.isNewSet = true;
    }

    this.setUnavailabilityData({ data: this.availabilitySets });
  }

  async getAllSetsCount(forceReload = false) {
    const stateCount = this.$state.params.unavailabilityCount;
    if (typeof stateCount !== 'undefined' && stateCount !== null && !forceReload) {
      this.allSetsCount = this.$state.params.unavailabilityCount;
    } else {
      this.allSetsCount = await this.AvailabilityUtils.getUnavailabilitiesCount(
        this.$state.params.userId
      );
    }
  }

  get isHistorical() {
    return this.history || (this.setData?.[0]?.details && isHistorical(this.setData?.[0]?.details));
  }

  get isReadonly() {
    return (
      (!this.Authentication.user.isManager &&
        (!this.Authentication.user.orgSettings.usersSetAvailability || this.isHistorical)) ||
      (this.Authentication.user.isManager && !this.UserUtils.canManageUser(this.user))
    );
  }
}

export default {
  template: `
    <availability-sets src="ctrl.availabilitySets"
      class="single-unavailability"
      ng-form="ctrl.availabilityForm"
      loading="ctrl.availabilityLoading"
      user="ctrl.user"
      read-only="ctrl.isReadonly"
      hide-header="ctrl.history || ctrl.hideHeader"
      single-set="true"
      all-sets-count="ctrl.allSetsCount"
      is-new-set="ctrl.isNewSet"
      go-back="ctrl.goBack()"
      ></availability-sets>
    `,
  controller: UnavailabilitySetController,
  controllerAs: 'ctrl',
  bindings: {
    setId: '=',
    setData: '=?',
    availabilityForm: '=?',
    setUnavailabilityData: '&',
    user: '<',
    userId: '<',
    history: '<',
    newSet: '<',
    hideHeader: '<',
    goBack: '&?',
  },
};
